import styled from "styled-components";

export const SocialIcon = styled.img`
	width: 30px;
	height: 30px;
	background: #ffffff;
	padding: 7px;
	border-radius: 40%;
`;
